export enum UiProperties {
  UNDEFINED = 'UNDEFINED',
  TEXT_BOLD_ITALIC = 'TEXT_BOLD_ITALIC',
  VISIBLE = 'VISIBLE',
  ICON_SRC = 'ICON_SRC',
  EXPANDED = 'EXPANDED',
  DESCRIPTION = 'DESCRIPTION',
  PLACEMARK_ICON_SRC = 'PLACEMARK_ICON_SRC'
}
